<template>
    <div class="responsiveSection__grid">
        <HighlightSection
            v-for="(section, index) in marketData.sections"
            :key="index"
            :section-data="section"
            :section-chart-data="section.contents"
            :locale="marketData.locale"
            :index="index"
            @set-global-settings="loadGlobalSettings" />
    </div>
</template>

<script>
    import HighlightSection from 'outlook/components/marketHighlights/highlightSection';
    import { CustomScriptLoader } from 'outlook/utils/loadScriptsOnDemand';
    import { essentialChartScripts } from 'outlook/utils/highchartScripts';
    import { mapState } from 'vuex';

    export default {
        components: {
            HighlightSection,
        },
        data() {
            return {
                scriptLoader: null,
                canLoadGlobalSettings: false,
            };
        },
        computed: {
            ...mapState([
                'marketData',
            ]),
        },
        watch: {
            canLoadGlobalSettings() {
                if (typeof Highcharts !== 'undefined') {
                    this.initHighchartsGlobalSettings();
                }
            },
        },
        methods: {
            loadEssentialHighchartsScripts() {
                this.scriptLoader = new CustomScriptLoader();
                this.scriptLoader.loadEssentialScripts(essentialChartScripts);
            },
            loadGlobalSettings($event) {
                this.canLoadGlobalSettings = $event;
            },
            initHighchartsGlobalSettings() {
                if (this.marketData.highchartsGlobalSettings) {
                    // eslint-disable-next-line no-undef
                    Highcharts.setOptions(JSON.parse(this.marketData.highchartsGlobalSettings));
                }
            },
        },
        created() {
            this.loadEssentialHighchartsScripts();
        },
        beforeDestroy() {
            this.scriptLoader.reset();
        },
    };
</script>
